import { ErrorPlatformEvent, interpret } from 'xstate'
import { HierarchyReadRepository } from '~/apps/hierarchies/domain/repositories'
import { hierarchiesContainer } from '~/apps/hierarchies/inversify.config'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import {
  AppMenuLocationsMachineContext,
  returnAppMenuLocationsMachine,
} from './machine'

export function appMenuLocationsMachineFactory(
  ctx: AppMenuLocationsMachineContext,
) {
  const machine = returnAppMenuLocationsMachine()
  return interpret(
    machine.withContext(ctx).withConfig({
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          event.data.name = `appMenuLocationsMachine ${event.type} error`
          sentryCapture(event.data, rootContainer)
        },
      },
      services: {
        fetchBookableCountries: async () =>
          await hierarchiesContainer
            .get(HierarchyReadRepository)
            .getCountries(ctx.langCode),
        fetchHierarchy: async ({ currentCountryPath }) =>
          await hierarchiesContainer
            .get(HierarchyReadRepository)
            .getHierarchyWithBookableOnly(
              currentCountryPath || '',
              ctx.langCode,
            ),
      },
    }),
  )
}
